import React from 'react';
import Modal from '../ui/Modal';
import Input from '../ui/Input';
import EventBus from '../../utils/EventBus';
import { campaignService } from '../../services/campaignService';
import styles from './TestSendModal.module.css';

const CHANNEL_LABELS = { push: 'Push', whatsapp: 'WhatsApp', sms: 'SMS', email: 'Email', rcs: 'RCS' };

// Per-channel target field — matches whatever contact detail that channel's
// provider actually needs (see pmw-click-backend's testSend.service.js).
const TARGET_FIELDS = {
  email:    { key: 'email',   label: 'Email address', placeholder: 'you@example.com',    hint: null },
  sms:      { key: 'phone',   label: 'Mobile number',  placeholder: '10-digit mobile number', hint: null },
  rcs:      { key: 'phone',   label: 'Mobile number',  placeholder: '10-digit mobile number', hint: null },
  whatsapp: { key: 'phone',   label: 'Mobile number',  placeholder: '10-digit mobile number', hint: 'Must have WhatsApp installed on this number.' },
  push:     { key: 'user_id', label: 'Test user ID',   placeholder: 'e.g. a pickmywork user_id', hint: 'Must be a real user_id with a signed-in device on file — a fake ID will report "no contact info".' },
};

class TestSendModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { value: '', sending: false };
    this.send = this.send.bind(this);
  }

  componentDidUpdate(prevProps) {
    // Clear the target field each time a different channel's test is opened
    // — carrying over e.g. an email typed for a previous Email test into a
    // freshly-opened SMS test would silently fail validation.
    if (this.props.channel !== prevProps.channel) this.setState({ value: '' });
  }

  send(e) {
    e.preventDefault();
    const { channel, template } = this.props;
    const field = TARGET_FIELDS[channel];
    const target = { [field.key]: this.state.value.trim() };

    this.setState({ sending: true });
    campaignService.testSend({ channel, template, target })
      .then(() => {
        this.setState({ sending: false, value: '' });
        EventBus.emit('toast', { type: 'success', message: `Test ${CHANNEL_LABELS[channel]} sent.` });
        this.props.onClose();
      })
      .catch((err) => {
        this.setState({ sending: false });
        EventBus.emit('toast', { type: 'error', message: err.message || 'Test send failed.' });
      });
  }

  render() {
    const { open, channel, onClose } = this.props;
    const { value, sending } = this.state;
    if (!channel) return null;
    const field = TARGET_FIELDS[channel];

    return (
      <Modal open={open} onClose={onClose} width="420px" title={`Send test — ${CHANNEL_LABELS[channel]}`}>
        <p className={styles.hint}>Sends the message you've drafted for this channel to one target, right now — no audience, no launch.</p>
        <form onSubmit={this.send}>
          <div className={styles.fi}>
            <label className={styles.fiLabel}>{field.label} <span className={styles.req}>*</span></label>
            <Input
              autoFocus
              placeholder={field.placeholder}
              value={value}
              onChange={(e) => this.setState({ value: e.target.value })}
            />
            {field.hint && <div className={styles.fiHint}>{field.hint}</div>}
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 18 }}>
            <button type="button" className={styles.ghostBtn} onClick={onClose}>Cancel</button>
            <button type="submit" className={styles.sendBtn} disabled={sending || !value.trim()}>
              {sending ? 'Sending…' : 'Send Test'}
            </button>
          </div>
        </form>
      </Modal>
    );
  }
}

export default TestSendModal;
